import { render, staticRenderFns } from "./overview-home.vue?vue&type=template&id=0ac4b946&scoped=true"
import script from "./overview-home.vue?vue&type=script&lang=js"
export * from "./overview-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac4b946",
  null
  
)

export default component.exports